/**
 * PlaceName Component
 * Inline badge component for place names in chat responses
 */

import React from 'react';
import {
  backgroundColors,
  strokeColors,
  typographyColors,
  spacing,
  borders,
  typography,
  fontPrimary,
} from '@/design-system/utils';

export interface PlaceNameProps {
  place: string;
  isBold?: boolean;
  showIcon?: boolean;
  onClick?: () => void;
}

export const PlaceName: React.FC<PlaceNameProps> = ({
  place,
  isBold = false,
  showIcon = false,
  onClick,
}) => {
  const [isHovered, setIsHovered] = React.useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent event bubbling
    e.preventDefault(); // Prevent default link behavior
    console.log('[PlaceName] Clicked on place:', place);
    onClick?.();
  };

  return (
    <span
      onClick={handleClick}
      onMouseEnter={() => onClick && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: spacing[0.5],
        paddingLeft: spacing[2],
        paddingRight: spacing[1.5],
        paddingTop: spacing[1],
        paddingBottom: spacing[1],
        marginBottom: spacing[1],
        backgroundColor:
          isHovered && onClick
            ? backgroundColors.alternate
            : backgroundColors.offset,
        border: `1px solid ${strokeColors.light}`,
        borderRadius: borders.radius.md,
        fontFamily: fontPrimary,
        fontSize: typography.size.sm,
        fontWeight: isBold ? typography.weight.bold : typography.weight.bold,
        color:
          isHovered && onClick
            ? typographyColors.alternate
            : typographyColors.primary,
        lineHeight: '1.6',
        whiteSpace: 'nowrap',
        cursor: onClick ? 'pointer' : 'default',
        verticalAlign: 'baseline',
        transition: 'background-color 0.2s ease, color 0.2s ease',
      }}
    >
      {place}
      {showIcon && (
        <svg
          width='14'
          height='14'
          viewBox='0 0 14 14'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          style={{
            flexShrink: 0,
          }}
        >
          <path
            d='M6.99935 1.75V12.25M6.99935 12.25L2.33268 7.58333M6.99935 12.25L11.666 7.58333'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      )}
    </span>
  );
};
